import styled from 'styled-components';

export const MyDiv = styled.div`
.card{
  border-radius: 8px;
}
.card-box{
  background-color: white;
  border-radius: 6px;
  padding: 41px 5px 25px;
  cursor: pointer;
}
`;
